import React from 'react';
import Flagship from '../../core/flagship';
import * as actions from '../../actions/appActions';
import RecentFavorites from '../dashboard/RecentFavorites';
import ActivityFeed from '../dashboard/ActivityFeed';
import NeedPricing from '../dashboard/NeedPricing';
import NewIos from '../dashboard/NewIos';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Grid, Icon, Label, Header, Loader } from 'semantic-ui-react';
import { Link } from 'react-router';
import '../../styles/dashboard.scss';

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        setTimeout(Flagship.closeSidebarNav,500);
    }

    componentDidMount() {
        document.title =  "Flagship / Dashboard";
    }

  render() {

      if ( this.props.token !== null ) {
          return (
              <div className="fade-in">
                  <Grid>
                      <Grid.Column floated="left" mobile={16} tablet={16} computer={8} largeScreen={5} widescreen={4}
                                   className="big-column">
                          <Header className="white-text">
                              My Favorites
                              <Link to="/user/favorites">
                                  <Label size="small" className="view-all float-right">
                                      <Icon name="caret right"/>
                                      View All
                                  </Label>
                              </Link>
                          </Header>
                          <RecentFavorites userId={this.props.userId}/>

                      </Grid.Column>

                      {this.props.userRole === "dpm" || this.props.userRole === "admin" ?
                      <Grid.Column floated="left" mobile={16} tablet={16} computer={8} largeScreen={5} widescreen={4}
                                   className="big-column">
                          <Header className="white-text">
                              Upcoming IOs
                              <Link to="/ios?status=publish">
                                  <Label size="small" className="view-all float-right">
                                      <Icon name="caret right"/>
                                      View All
                                  </Label>
                              </Link>
                          </Header>
                          <NewIos/>
                      </Grid.Column> : null }


                      {this.props.userRole === "proposal_strategist" || this.props.userRole === "admin" ?
                      <Grid.Column floated="left" mobile={16} tablet={16} computer={8} largeScreen={5} widescreen={4}
                                   className="big-column">
                          <Header className="white-text">
                              Need Pricing
                              <Link to="/rfps?status=publish&orderby=due">
                                  <Label size="small" className="view-all float-right">
                                      <Icon name="caret right"/>
                                      View All
                                  </Label>
                              </Link>
                          </Header>
                          <NeedPricing/>
                      </Grid.Column> : null }
                      <Grid.Column floated={this.props.userRole === "admin" ? "left" : "right"} mobile={16} tablet={16} computer={8} largeScreen={5} widescreen={4}
                                   className="big-column">
                          <Header className="white-text">
                              Recent Activity
                          </Header>
                          <ActivityFeed userId={this.props.userId} />
                      </Grid.Column>
                  </Grid>
              </div>
          );
      } else {
          return (
              <div><Loader className="flagship-loader" active={true} inline /></div>
          );
      }
  }
}

function mapStateToProps(state) {
    return {
        token: state.main.token,
        username: state.main.username,
        firstName: state.main.userFirstName,
        userRole: state.main.userRole,
        userId: state.main.userId
    };
}

function mapDispatchToProps(dispatch) {

    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);




// WEBPACK FOOTER //
// ./src/components/views/Dashboard.js